export default __webpack_public_path__ + "static/media/Group 702.000bf640.png";